<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { HOME_TOUR_STEPS } from '@features/feature-tour'
import { FeatureTourSpot } from '@features/feature-tour'
import { useCustomerStore } from '@entities/customer'

import { useBtnSupport } from './btn-support.hook'
import HeaderNavItem from './HeaderNavItem.vue'
import DropdownSupport from './DropdownSupport.vue'

defineOptions({
  name: 'BtnSupport',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const customerStore = useCustomerStore()

const { disabled } = useBtnSupport({ customerStore })
</script>

<template>
  <FeatureTourSpot
    v-if="customerStore.isTypePaid"
    :id="HOME_TOUR_STEPS.BTN_SUPPORT"
  >
    <HeaderNavItem
      :layout="layout"
      :icon="layout === 'vertical' ? 'message' : 'comments'"
      label="Support"
      :disabled="disabled"
    >
      <template #menu>
        <DropdownSupport />
      </template>
    </HeaderNavItem>
  </FeatureTourSpot>
</template>
